// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"510d4c04","255":"10ce7b4e","298":"a3cceb70","951":"6f5b8e67","966":"96e888b9"}[chunkId] + ".chunk.css";
};